import classNames from "classnames";
import Icon from "~/assets/icons/Icon";

type TextProps = {
  className?: string;
  text: string;
};
type TextsProps = {
  className?: string;
  texts: string[] | null;
};

function Chips({ className, texts }: TextsProps) {
  if (texts === null || texts.length === 0) return null;

  const filteredTexts = texts.filter((text) => Boolean(text));

  return (
    <ul className={classNames("flex flex-wrap gap-2", className)}>
      {filteredTexts.map((text) => (
        <li key={text}>
          <Chip text={text} />
        </li>
      ))}
    </ul>
  );
}

function Chip({ className, text }: TextProps) {
  return (
    <p
      className={classNames(
        "flex items-center gap-2 bg-secondary-400 rounded-full px-3 text-xs text-white whitespace-nowrap py-1",
        className
      )}
    >
      <Icon name="check" className="w-4 h-4" />
      {text}
    </p>
  );
}

export { Chips, Chip };
